import classNames from 'classnames/bind';
import styles from './SignUp.module.css';

import { useLocation, useNavigate } from 'react-router-dom';

import Button from '../../../components/Button';
import {
  MINOR_STUDENT_DESC,
  LEGAL_REPRESENTATIVE_REQUIRED,
  SIGNUP,
  STUDENT_DESC,
  TEACHER_DESC,
} from '../../../constants';
import { Fragment } from 'react';

export default function SignUp() {
  const cx = classNames.bind(styles);
  const navigate = useNavigate();
  const { state } = useLocation();

  const typeList = [
    { type: 'teacher', name: TEACHER_DESC },
    { type: 'student', name: STUDENT_DESC },
    { type: 'minor', name: MINOR_STUDENT_DESC },
  ];

  const selectType = (type: string) => {
    navigate(type, {
      state: {
        type,
        userProfile: state?.userProfile,
      },
    });
  };

  return (
    <>
      <h2>{SIGNUP}</h2>
      <div>
        <div className={cx('signup_type')}>
          {typeList.map(({ type, name }) => (
            <Fragment key={type}>
              <Button
                classnames={[`signup_type_${type}`]}
                name={name}
                isChildrenTop={true}
                handleClick={() => selectType(type)}
              >
                <i className={cx('svg_i', type)}></i>
              </Button>
              {type === 'minor' && (
                <div className={cx('desc')}>
                  {LEGAL_REPRESENTATIVE_REQUIRED}
                </div>
              )}
            </Fragment>
          ))}
        </div>
      </div>
    </>
  );
}
